const UploadComponent = ({ loading, selectedFiles, editable, setSelectedFiles, handleUpload, handleClearAll, setError }) => {

  const handleFileSelect = (event) => {
    const files = Array.from(event.target.files);
    const idBase = Date.now();

    const newFiles = files.map((file, index) => {
      let format = 'Unsupported'
      let fileName = file.name;

      if (file.type.includes('application/pdf') || file.name.endsWith('.pdf')) {
        format = 'PDF'
      } else if (file.type.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') || file.name.endsWith('.xlsx')) {
        format = 'XLSX'
      } else if (file.type.includes('application/vnd.ms-excel.sheet.macroEnabled.12') || file.name.endsWith('.xlsm')) {
        format = 'XLSM'
      }

      return {
        id: idBase + index,
        name: fileName,
        format: format,
        current: false,
        renewal: false,
        pages: "",
        file: file
      };
    });

    setSelectedFiles(prev => [...prev, ...newFiles]);
  };

  const handleSelectCurrentPlan = (fileId) => {
    setSelectedFiles(prev =>
      prev.map(file =>
        file.id === fileId ? { ...file, current: true } : { ...file, current: false }
      )
    );
  };

  const handleSelectRenewalPlan = (fileId) => {
    setSelectedFiles(prev =>
      prev.map(file =>
        file.id === fileId ? { ...file, renewal: true } : { ...file, renewal: false }
      )
    );
  };

  const handlePageChange = (fileId, value, format) => {
    // Filter input for PDF files: only allow digits, hyphens, commas, and spaces
    let filteredValue = value;
    if (format === 'PDF') {
      filteredValue = value.replace(/[^0-9\-,\s]/g, '');
    }
    
    setSelectedFiles(prev =>
      prev.map(file =>
        file.id === fileId ? { ...file, pages: filteredValue } : file
      )
    );
  };

  const handleRemoveFile = (fileId) => {
    setSelectedFiles(prev => prev.filter(file => file.id !== fileId));
  };

  return (
    <div className="mb-6">

      {/* File Selection Section */}
      {editable && (
        <div className="mb-4">
          <h2 className="text-xl font-semibold mb-2">Select Files</h2>
          <div>
            <input
              type="file"
              multiple
              accept="application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,application/vnd.ms-excel.sheet.macroEnabled.12"
              className="block w-full border rounded p-2"
              onChange={handleFileSelect}
              disabled={loading}
            />
            <span className="text-xs text-gray-500 mt-1 block">
              You can select multiple files at once. Supported formats: PDF, XLSX, XLSM
            </span>
          </div>
        </div>
      )}

      {/* Files Table */}
      {selectedFiles.length > 0 && (
        <div className="mb-4">
          <h2 className="text-xl font-semibold mb-2">Upload Files</h2>
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border border-gray-300">
              <thead>
                <tr className="bg-gray-50">
                  <th className="border border-gray-300 px-4 py-2 text-left">File Name</th>
                  <th className="border border-gray-300 px-4 py-2 text-center">File Type</th>
                  <th className="border border-gray-300 px-4 py-2 text-center">Current Plan</th>
                  <th className="border border-gray-300 px-4 py-2 text-center">Renewal Plan</th>
                  <th className="border border-gray-300 px-4 py-2 text-center">Pages/Sheets to analyze</th>
                  <th className="border border-gray-300 px-4 py-2 text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {selectedFiles.map((file) => (
                  <tr key={file.id} className="hover:bg-gray-50">
                    <td className="border border-gray-300 px-4 py-2">
                      <span className="text-sm font-medium">{file.name}</span>
                    </td>
                    <td className="border border-gray-300 px-4 py-2 text-center">
                      <span className={`inline-block px-2 py-1 rounded text-xs font-medium ${file.format === 'PDF' ? 'bg-red-100 text-red-800' :
                          file.format === 'XLSX' || file.format === 'XLSM' ? 'bg-green-100 text-green-800' :
                            'bg-gray-100 text-gray-800'
                        }`}>
                        {file.format}
                      </span>
                    </td>
                    <td className="border border-gray-300 px-4 py-2 text-center">
                      <input
                        type="radio"
                        name="currentPlan"
                        value={file.id}
                        checked={file.current}
                        onChange={() => handleSelectCurrentPlan(file.id)}
                        className="w-4 h-4 text-blue-600"
                        disabled={loading || !editable}
                      />
                    </td>
                    <td className="border border-gray-300 px-4 py-2 text-center">
                      <input
                        type="radio"
                        name="renewalPlan"
                        value={file.id}
                        checked={file.renewal}
                        onChange={() => handleSelectRenewalPlan(file.id)}
                        className="w-4 h-4 text-blue-600"
                        disabled={loading || !editable}
                      />
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      <input
                        type="text"
                        className="w-full border rounded p-1 text-sm"
                        placeholder={
                          file.format === 'PDF'
                            ? "e.g. 2,3,7-9"
                            : "e.g. Sheet1,Sheet2"
                        }
                        value={file.pages}
                        onChange={(e) => handlePageChange(file.id, e.target.value, file.format)}
                        disabled={loading || !editable}
                      />
                      <span className="text-xs text-gray-500 block mt-1">
                        {file.format === 'PDF'
                          ? "Page numbers or ranges"
                          : "Sheet names"
                        }
                      </span>
                    </td>
                    <td className="border border-gray-300 px-4 py-2 text-center">
                      <button
                        onClick={() => handleRemoveFile(file.id)}
                        className="text-red-600 hover:text-red-800 text-sm font-medium disabled:opacity-50"
                        disabled={loading || !editable}
                      >
                        Remove
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Upload Button */}
      {selectedFiles.length > 0 && (
        <div className="flex gap-3 mt-4 justify-center">
          {editable && (
            <button
              className="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition disabled:opacity-50"
              onClick={handleUpload}
              disabled={loading || selectedFiles.length === 0}
            >
              {loading ? "Extracting Plans..." : "Extract Plans"}
            </button>
          )}
          <button
            className="px-6 py-2 bg-gray-600 text-white rounded hover:bg-gray-700 transition disabled:opacity-50"
            onClick={() => handleClearAll()}
            disabled={loading}
          >
            Clear All
          </button>
        </div>
      )}

      {/* {selectedFiles.length === 0 && (
        <p className="text-gray-500 text-sm mt-2">No files uploaded yet. Please select files to upload.</p>
      )} */}
    </div>
  );
};

export default UploadComponent;
